const footerEn = {
  'date': {
    'format': 'dd.mm.yyyy',
  },
};

export default footerEn;
